import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class Licencia extends DefaultService {
  constructor() {
    super('licencia');
  }

  changeEstatus(licencia: number, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/changestatus`, data);
  }

  newYear(locacion: string, anio: number, data: any): Promise<any>{
    return API.post(`licencia/${locacion}/newyear/${anio}`, data);
  }

  changeEstatusUsoSuelo(licencia: number, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/changestatususosuelo`, data);
  }

  getConvenio(): Promise<any>{
    return API.get('convenio/list');
  }

  saveConvenios(licencia: number, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/saveConvenios`, data);
  }

  checkPendingLiquorLicenses(): Promise<any>{
    return API.get('establecimientos/check-pending-licencias-bebidas-alcoholicas');
  }

  saveSolicitudFiscalizacion(licencia: number, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/saveSolicitudFiscalizacion`, data);
  }

  saveSolicitudFiscalizacionMusica(licencia: number, data: any): Promise<any>{
      return API.post(`licencia/${licencia}/saveSolicitudFiscalizacionMusica`, data);
  }

  getSolicitudExtraordinarias(licencia: any, pagination: any): Promise<any>{
    let query = new URLSearchParams(pagination).toString();
    return API.get(`licencia/${licencia}/getSolicitudExtraordinarias?${query}`);
  }

  getSolicitudMusica(licencia: any): Promise<any>{
      return API.get(`licencia/${licencia}/getSolicitudMusica`);
  }

  findSolicitudExtraordinaria(licencia: any, solicitud: any): Promise<any>{
    return API.get(`licencia/${licencia}/findSolicitudExtraordinaria/${solicitud}`);
  }

  getReciboPago(locacion: any, tipo: any): Promise<any>{
    return API.post(`licencia/${locacion}/findReciboPago/${tipo}`);
  }

  actualizarSolicitudFiscalizacion(licencia: number, solicitud: any, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/actualizarSolicitudFiscalizacion/${solicitud}`, data);
  }

  imprimirSolicitud(url: any, data: any, type: any, name: string){
    return API.request({
        url: url,
        data: data,
        method: type,
        responseType: 'blob'
    });
  }

  uploadSolicitudFirmada(licencia: any, solicitud: any, data: any): Promise<any>{
    return API.request({
      url: `licencia/${licencia}/uploadSolicitudFirmada/${solicitud}`,
      data: data,
      method: `POST`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
    });
  }

  uploadReciboPagoFiscalizacion(licencia: any, solicitud: any, data: any): Promise<any>{
    return API.request({
      url: `licencia/${licencia}/uploadReciboPagoFiscalizacion/${solicitud}`,
      data: data,
      method: `POST`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
    });
  }

   uploadReciboPagoCambioDomicilioDU(solicitud: any, data: any): Promise<any>{
    return API.request({
      url: `licencia/1/uploadReciboPagoCambioDomicilioDU/${solicitud}`,
      data: data,
      method: `POST`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
    });
  }

  uploadReciboPago(locacion: any, data: any): Promise<any>{
    return API.request({
      url: `licencia/${locacion}/uploadReciboPago`,
      data: data,
      method: `POST`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
    });
  }


  uploadReciboPagoDU(locacion: any, data: any): Promise<any>{
    return API.request({
      url: `licencia/${locacion}/uploadReciboPagoDU`,
      data: data,
      method: `POST`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
    });
  }

  changeSolicitudEstatus(licencia: any, solicitud: any, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/changeSolicitudEstatus/${solicitud}`, data);
  }

  viewEdoCuentaFiscalizacion(url: any, data: any, type: any, name: string): Promise<any>{
    return API.request({
      url: url,
      data: data,
      method: type,
      responseType: 'blob'
    });
  }

  viewConstanciaExtraordinaria(url: any, data: any, type: any, name: string): Promise<any>{
    return API.request({
      url: url,
      data: data,
      method: type,
      responseType: 'blob'
    });
  }
  
  notifyEdoRs(locacion: any, data: any): Promise<any>{
    return API.post(`contribuyente/notifyEdoRs/${locacion}`, data);
  }

  getHistoricoLicencia(external: any): Promise<any>{
    return API.post(`licencias/getHistoricoLicencia/${external}`);
  }

  getMulta(external_id: any): Promise<any>{
    return API.get('licencias/getMulta/' + external_id);
  }

  copiarSolicitudFiscalizacion(licencia: number, solicitud: any, data: any): Promise<any>{
    return API.post(`licencia/${licencia}/copiarSolicitudFiscalizacion/${solicitud}`, data);
  }

  getLicenciaEstatus(locacion: any, anio: any): Promise<any>{
    return API.get('licencia/' + locacion + '/' + anio + '/getLicenciaEstatus');
  }
}

export default new Licencia;